import { Button, Flex, Portal } from '@radix-ui/themes';
import mixpanel from 'mixpanel-browser';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '~/components/Icon';
import Notification from '~/components/Notification';
import useNotification from '~/hooks/use-notification';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${props => props.theme.zIndex.notification};
  width: 100%;
  margin-top: 14px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

function NotificationCenter() {
  const { notifications, cancelNotification } = useNotification();

  return (
    <Portal container={document.getElementById('root')}>
      <Wrapper>
        <List>
          {notifications.map((notification, idx) => (
            <Notification
              key={idx}
              type={notification.type}
              forcedTheme={notification.forcedTheme}
              onClick={() => cancelNotification(notification.id)}
              icon={
                notification.icon && (
                  <Icon
                    inline
                    {...notification.icon}
                  />
                )
              }
            >
              <Flex
                justify='between'
                width='100%'
              >
                <div>{notification.message}</div>
                <div>
                  {notification.mode === 'timed' ? (
                    <Icon
                      name='close'
                      width={15}
                      height={15}
                      color='currentColor'
                    />
                  ) : (
                    <Button
                      size='1'
                      variant='outline'
                      onClick={() => mixpanel.track('Click on notification button', notification)}
                    >
                      <NavLink to={notification.buttonHref}>{notification.buttonLabel || 'See more'}</NavLink>
                    </Button>
                  )}
                </div>
              </Flex>
            </Notification>
          ))}
        </List>
      </Wrapper>
    </Portal>
  );
}

export default NotificationCenter;
